import React from "react";
import { useHistory } from "react-router-dom"; // Import useHistory for navigation
import "./OrderCountComponent.css"; // Import CSS for styling

function OrderCountComponent({count, label,onClick}) {
  const history = useHistory(); // Initialize useHistory

  // Function to handle card click
  const handleCardClick = () => {
    history.push("/WarehouseOrderList"); // Navigate to WarehouseOrderList screen
  };

  return (
    <div className="card-container">
      <div className="card" onClick={handleCardClick} style={{ cursor: "pointer" }}>
      <p className="card-count">{count}</p>
        <h2 className="card-title">Total Orders</h2>
      
      </div>
    </div>
  );
}

export default OrderCountComponent;